import { inject, provideEnvironmentInitializer } from '@angular/core';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import { default as de } from '../i18n/de.json';
import { default as deTitles } from '../i18n/de.titles.json';
import { kundenabfrageRoutes } from './kundenabfrage.routes';
import { SOFTLINE_PERMISSION_CUSTOMER_QUERY } from './kundenabfrage.shared';

export const kundenabfrageProviders = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'kundenabfrage',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: 'Kundenabfrage',
      icon: 'fa-regular fa-user',
      route: '/kundenabfrage',
      permission: SOFTLINE_PERMISSION_CUSTOMER_QUERY,
      group: getModuleGroupByName('Statistik'),
    });
  }),
];

export function provideKundenabfrageModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'wws/kundenabfrage',
        title: '#CUSTOMER.TITLE',
        icon: 'fa-regular fa-user',
        route: '/kundenabfrage',
        permission: SOFTLINE_PERMISSION_CUSTOMER_QUERY,
        group: getModuleGroupByName('Statistik'),
      },
      withSoftAppsModuleRoutes({ app: kundenabfrageRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      })
    ),
  ];
}
